import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isAcceptedByBuyer } from '@makemydeal/dr-sales-checkin-utils';
import { getWorkflowInputsFromState } from '../workflowInputs';
import type { WorkflowRule } from '../types';

// Showroom mode: buyer has accepted a version the manager published to Sales View.
// Outranks deskedRule and sentForDeskingRule — see the rule table in workflowEvaluator.ts.
export const acceptedRule: WorkflowRule = (state: any): WorkflowStatus | null =>
    isAcceptedByBuyer(getWorkflowInputsFromState(state)) ? WorkflowStatus.ACCEPTED : null;
